import React from "react";
import Button from "domains/ui/components/Button";
import WithGradientEffect from "domains/ui/components/WithGradientEffect";

import { Flex, Image, Text, VStack } from "@chakra-ui/react";

export interface ModelListEmptyStateProps {
  reason: "no-models" | "no-search-results";
}

export default function ModelListEmptyState({
  reason = "no-models",
}: ModelListEmptyStateProps) {
  return (
    <Flex data-testid="asset-gallery-empty-state">
      <VStack mt={4}>
        <WithGradientEffect>
          <Image
            w={200}
            h={200}
            alt="Empty state"
            src="/ui/model-empty-state.svg"
          />
        </WithGradientEffect>

        <VStack pt={3} pb={5}>
          <Text size="title.md">No Models</Text>

          {reason === "no-models" && (
            <Text color="textSecondary" size="body.md">
              {"You haven't made any custom models yet."}
            </Text>
          )}

          {reason === "no-search-results" && (
            <Text color="textSecondary" size="body.md">
              {"No models matching your search or filter criteria."}
            </Text>
          )}
        </VStack>

        {reason === "no-models" && (
          <Button variant="secondary" internalLink="/models/new">
            Create One Now
          </Button>
        )}
      </VStack>
    </Flex>
  );
}
